<script lang="ts">
	import { copyToClipBoard } from '$lib/common';
	import IconClipboard from '$lib/icons/IconClipboard.svelte';
	import { quintOut } from 'svelte/easing';
	import { draw } from 'svelte/transition';

	interface Props {
		textToCopy: string;
		title?: string;
		showIcon?: boolean;
		children?: import('svelte').Snippet;
		[key: string]: any
	}

	let {
		textToCopy,
		title = 'Link kopieren',
		showIcon = true,
		children,
		...rest
	}: Props = $props();

	let showSlot = $state(true);
	let button: HTMLButtonElement = $state();

	function onClick() {
		copyToClipBoard(textToCopy);

		const originalWidth = button.style.width;
		const tempWidth = button.offsetWidth;
		button.style.width = `${tempWidth}px`;
		showSlot = false;
		setTimeout(() => {
			showSlot = true;
			button.style.width = originalWidth;
		}, 2500);
	}
</script>

<button
	bind:this={button}
	onclick={onClick}
	{title}
	class="btn min-w-fit grow px-2 py-1 sm:grow-0 {rest.class}"
	data-testid="copy-link-btn"
>
	{#if showSlot}
		{#if showIcon}
			<IconClipboard class=" mr-1 inline-block" />
		{/if}
		{@render children?.()}
	{:else}
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			class="mr-1 inline-block size-5"
		>
			<path
				in:draw={{ duration: 900, easing: quintOut, delay: 100 }}
				stroke-linecap="round"
				stroke-linejoin="round"
				d="m4.5 12.75 6 6 9-13.5"
			/>
		</svg>
		Kopiert
	{/if}
</button>
